import { render, staticRenderFns } from "./Equal.vue?vue&type=template&id=148c37fc&scoped=true"
var script = {}
import style0 from "./Equal.vue?vue&type=style&index=0&id=148c37fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c37fc",
  null
  
)

export default component.exports